/**
 * @flow
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import LanguageStore from './lang';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'react-dates/lib/css/_datepicker.css';
import './assets/styles/index.css';
import 'react-widgets/dist/css/react-widgets.css';

import App from './App';
import { unregister } from './registerServiceWorker';

ReactDOM.render(
  <I18nextProvider i18n={LanguageStore.i18n}>
    <App />
  </I18nextProvider>,
  document.getElementById('root'),
);
// registerServiceWorker();
unregister();




// WEBPACK FOOTER //
// ./src/index.js